module.exports = require('./helpers/bundle-url').getBundleURL('3p50z') + "pipelines-promotion-icon.8b4bf826.png";